'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _camelize = require('../utils/camelize');

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
} // Test if a property supported as it is.
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.


exports['default'] = {
  supportedProperty: function supportedProperty(prop, style) {
    return (0, _camelize2['default'])(prop) in style ? prop : false;
  }
};